import $ from 'jquery';

export default class Form {
  init(){
    this.parentFocus();
    this.togglePasswordVisibility();
  }

  parentFocus() {
    $('.js-tso-child-focus').focus(function () {
      $(this).closest('.js-tso-parent-focus').addClass('focus');
    });
    $('.js-tso-child-focus').focusout(function () {
      $(this).closest('.js-tso-parent-focus').removeClass('focus');
    });
  }

  togglePasswordVisibility() {
    $('button[data-action="tso-show-password"]').on('click', function () {
      var elm = $(this).closest('.input-group').children('input.js-tso-visible-password');
      if (elm.attr('type') === 'password') {
        elm.attr('type', 'text');
        $(this).text($(this).data('textHide'));
      } else {
        elm.attr('type', 'password');
        $(this).text($(this).data('textShow'));
      }

    });
  }
}
